export default __webpack_public_path__ + "static/media/magnifier.c0c5ddba.svg";